import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import LayoutWrapper from './components/Layout/LayoutWrapper';
import Leaderboard from './components/Leaderboard';
import ProfilePage from './pages/ProfilePage'; 
import CreatePage from './pages/CreatePage';
import TokenProfile from './pages/TokenProfile';
import LeaderboardPage from './pages/LeaderboardPage';
import BrowsePage from './pages/BrowsePage';
import HallOfFamePage from './pages/HallOfFamePage';
import AdminPage from './pages/AdminPage';
import RoundStatusDisplay from './components/RoundStatusDisplay';

function App() {
  const [user, setUser] = useState(null);

  const currentContributions = [
    { id: 'rare', ticker: '$RARE', contributions: 5.2 },
    { id: 'flop', ticker: '$FLOP', contributions: 2.8 },
    { id: 'wow', ticker: '$WOW', contributions: 1.1 },
  ];
  const totalSolana = currentContributions.reduce((sum, coin) => sum + coin.contributions, 0);
  const previousWinners = [
    { id: 'moon', ticker: '$MOON', contributions: 6.9 },
    { id: 'zoom', ticker: '$ZOOM', contributions: 4.2 },
  ];

  return (
    <LayoutWrapper user={user} setUser={setUser}>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <RoundStatusDisplay />
              <h2 style={{ textAlign: 'center', color: '#FAFF00', fontFamily: 'VT323' }}>Current Round</h2>
              <Leaderboard coins={currentContributions} />
              <h2 style={{ textAlign: 'center', color: '#FAFF00', fontFamily: 'VT323' }}>Previous Winners</h2>
              <Leaderboard coins={previousWinners} />
            </>
          }
        />
        <Route path="/profile" element={<ProfilePage user={user} />} />
        <Route path="/create" element={<CreatePage />} />
        <Route path="/token/:ticker" element={<TokenProfile />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/browse" element={<BrowsePage />} />
        <Route path="/fame" element={<HallOfFamePage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </LayoutWrapper>
  );
}

export default App;
